// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Mulish_9738f2', '__Mulish_Fallback_9738f2'","fontStyle":"normal"},"className":"__className_9738f2","variable":"__variable_9738f2"};